import { ReportsProvider } from '@reports/presentation/contexts';
import { ProductsReportContent } from '@reports/presentation/components/specific/ProductsReport';
import { PageLayout } from '@reports/presentation/components/base/PageLayout';

/**
 * Products Report Page
 *
 * Entry point for the Products Report.
 * Infrastructure dependencies are managed by composition root (initialized in App bootstrap).
 * Each report page is isolated with its own state through ReportsProvider.
 */
export const ProductsReportPage = () => {
  return (
    <PageLayout>
      <ReportsProvider>
        <ProductsReportContent />
      </ReportsProvider>
    </PageLayout>
  );
};
